import { getParsedLocalStorageJson } from 'util/localStorage';
import { parseUserConfigFlags } from 'user/userConfigParser';
import { parseUserDetails } from 'user/userDetailsParser';
import { parseSupportInfo } from 'user/supportInfoParser';
import { parseProductValidationValues } from 'user/productValidationValuesParser';
import { setUserConfigFlags, setUserDetails, setSupportInfo, setProductValidationValues } from 'user';
import { initializeUnitQty } from 'util/unitConversion';

import { datadogRum } from '@datadog/browser-rum';

export const processUserConfigFlags = ({dispatch, rawFlags }) => {
  // localFlags are used solely in development environments. They override any flags parsed from
  // the rawFlags param. The rationale for using localFlags is that sometimes it's helpful to locally test a
  // feature without disrupting other user's expected behavior of a shared account.
  const localFlags = getParsedLocalStorageJson('featureFlags');
  const flags = parseUserConfigFlags(rawFlags);
  const combinedFlags = {...flags, ...localFlags};
  dispatch(setUserConfigFlags(combinedFlags));
  return Promise.resolve(flags);
};

export const processUserDetails = ({ dispatch, rawUserDetails }) => {
  const details = parseUserDetails(rawUserDetails);
  const unitsOfMeasureTemplate = details.unitsOfMeasureTemplate;
  const accountCountry = details.accountCountry;
  initializeUnitQty(unitsOfMeasureTemplate, accountCountry);
  dispatch(setUserDetails(details));
  const roles = details?.roles || [];
  datadogRum.setUserProperty('isClient', roles.includes('Client'));
  datadogRum.setUserProperty('isEmployee', roles.includes('Employee'));
  datadogRum.setUserProperty('isSupportEmployee', roles.includes('Support Employee'));
  datadogRum.setUserProperty('isFVSupportDash', roles.includes('FieldViewPlus Support Dash'));
  datadogRum.setUserProperty('isFVProxy', roles.includes('FieldViewPlus Proxy'));
  datadogRum.setUserProperty('accountCountry', details.accountCountry);
  return Promise.resolve(details);
};

export const processSupportInfo = ({ dispatch, rawSupportInfo }) => {
  const supportInfo = parseSupportInfo(rawSupportInfo);
  dispatch(setSupportInfo(supportInfo));
  return Promise.resolve(supportInfo);
};

export const processProductValidationValues = ({ dispatch, rawProductValidationValues, unitsOfMeasureTemplate }) => {
  const productValidationValues
    = parseProductValidationValues(rawProductValidationValues, unitsOfMeasureTemplate);
  dispatch(setProductValidationValues(productValidationValues));
  return Promise.resolve(productValidationValues);
};

